import { render } from "./TastesConfig.vue?vue&type=template&id=d6d2f532"
import script from "./TastesConfig.vue?vue&type=script&lang=js"
export * from "./TastesConfig.vue?vue&type=script&lang=js"

import "./TastesConfig.vue?vue&type=style&index=0&id=d6d2f532&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__